import React from "react";
import PropTypes from "prop-types";

import DialogFormWithMutation from "dialogs/DialogFormWithMutation";
import { FormGroupTitle, FormTextField } from "ui/Form";

import {
  UPDATE_BILLING_URL_MUTATION,
  READ_SERVICES_QUERY_NAME,
} from "graphqlQueries/system";

const fieldsWithPlaceForError = ["url"];

const UpdateBillingUrlDialog = (props) => {
  const { url = "" } = props;
  const initialValues = {
    url,
  };

  return (
    <DialogFormWithMutation
      mutationQueries={UPDATE_BILLING_URL_MUTATION}
      refetchQueries={[READ_SERVICES_QUERY_NAME]}
      initialValues={initialValues}
      fieldsWithPlaceForError={fieldsWithPlaceForError}
      title="New billing URL"
      submitButtonName="Save"
      className="dialog-default-width"
      {...props}
    >
      <FormGroupTitle title="Billing URL" />
      <FormTextField name="url" label="URL" />
    </DialogFormWithMutation>
  );
};

UpdateBillingUrlDialog.propTypes = {
  url: PropTypes.string,
};

export default UpdateBillingUrlDialog;
